import { displayNameSchema, usernameSchema } from '../lib';
import { interestsAndSkillsSchema, aboutYouSchema } from '../lib/users';
import { z } from 'zod';

export const hackathonOnboardingSchema = z.object({
  aboutYou: aboutYouSchema,
  interestsAndSkills: interestsAndSkillsSchema,
});

export type HackathonOnboardingBody = z.infer<typeof hackathonOnboardingSchema>;

export type HackathonOnboardingResponse = {
  id: number;
  username: string;
};

export const onboardingDetailsSchema = z.object({
  username: usernameSchema,
  displayName: displayNameSchema,
});

export type OnboardingBody = z.infer<typeof onboardingDetailsSchema>;

export type OnboardingResponse = {
  message: string;
};
